<template src="./SideNavigationITFHistories.html" />

<script>
/**
 * 右ナビ 投信閲覧履歴コンポーネント
 * @vue-data {Array<Object>} histories 投信閲覧履歴オブジェクト
 * @module modules/SideNavigation/SideNavigationFinancialItemHistories
 */
export default {
  name: 'SideNavigationITFHistories',
  props: {
    histories: {
      type: Array,
      required: true,
    },
  },
  computed: {
    /**
     * 閲覧履歴が存在すれば真
     * @return {Boolean}
     */
    hasHistory() {
      if (!this.histories.length) return false;

      return this.histories.length > 0;
    },
    /**
     * ITF上で比較機能が使える条件が整っていれば真
     * @return {Boolean}
     */
    isComparisonAvailableOnItf() {
      if (!this.histories.length) return false;

      return this.histories.length >= 2;
    },
    /**
     * ITFのファンド比較のURL
     * @return {string}
     */
    itfCompareUrl() {
      let codes = this.histories.map(item => item.fundCode).join(',');
      return `https://itf.minkabu.jp/fund/compare?fund_ids=${codes}&utm_source=minkabu&utm_medium=contents&utm_campaign=fund_compare_20250625`;
    },
  },
  methods: {
    /**
     * 計測用のタグを追加したITF個別銘柄ページのURL
     * @return {String}
     */
    customizedItfFundUrl(code) {
      return `${this.itfFundUrl(code)}?utm_source=minkabu&utm_medium=sidenavi&utm_campaign=recently_viewed`;
    },
  },
};
</script>
